import { USER_LOGOUT } from '../actions';
import {
  PRODUCT_LEVEL_PROFIT_AND_LOSS_BANNER_SKIPPED,
  SET_ACCESS_DENIED_WARNING_SHOW,
  SET_DASHBOARD_INSIGHTS_WIDGET_OPEN,
  SET_HIDE_PRODUCTS_WITHOUT_FINANCES,
  SET_MOBILE_APP_BANNER_SKIPPED,
  SET_RECOMMENDED_ALTERNATIVE_BANNER_SHOW,
  SET_RECOMMENDED_ALTERNATIVE_BANNER_SKIPPED,
  SET_REPORTS_CONFIG,
  SET_SERVICE_ENDING_BANNER_SHOW,
  SET_SERVICE_ENDING_BANNER_SKIPPED,
  SET_SKIPPED_DISCONNECTED_ACCOUNTS,
  SET_SKIPPED_PPC_NEEDS_RECONNECT,
  SET_SP_API_EXPIRED_WARNING_SHOW,
  SET_SP_API_EXPIRED_WARNING_SKIPPED,
  SET_TABLE_CONFIG
} from '../saga/userPreferences';

const initialState = {
  accessDeniedBannerShow: false,
  accessDeniedSkipped: false,
  ppcNeedsReconnectSkipped: false,
  spApiExpiredWarningShow: false,
  spApiExpiredWarningSkipped: false,
  productLevelProfitAndLossBannerSkipped: false,
  accountsWarningShow: false,
  mobileAppBannerSkipped: false,
  tablesConfig: {},
  reports: {},
  beta: {
    unitsEconomics: false
  },
  hideProductsWithoutFinances: false,
  dashboardInsightsWidgetOpen: true,
  serviceEndingBannerShow: true,
  serviceEndingBannerSkipped: false,
  recommendedAlternativeBannerShow: true,
  recommendedAlternativeBannerSkipped: false
};
export const userPreferencesSelector = state => state.userPreferences;

const userPreferences = (state = initialState, action) => {
  switch (action.type) {
    case SET_SKIPPED_DISCONNECTED_ACCOUNTS: {
      return { ...state, accessDeniedSkipped: action.payload };
    }
    case SET_ACCESS_DENIED_WARNING_SHOW: {
      return { ...state, accessDeniedBannerShow: action.payload };
    }
    case SET_TABLE_CONFIG: {
      const { id, config } = action;
      return { ...state, tablesConfig: { ...state.tablesConfig, [id]: config } };
    }
    case SET_MOBILE_APP_BANNER_SKIPPED: {
      return { ...state, mobileAppBannerSkipped: action.payload };
    }
    case SET_REPORTS_CONFIG: {
      return { ...state, reports: { ...state.reports, ...action.payload } };
    }
    case USER_LOGOUT: {
      return { ...initialState, mobileAppBannerSkipped: state.mobileAppBannerSkipped };
    }
    case SET_HIDE_PRODUCTS_WITHOUT_FINANCES: {
      return { ...state, hideProductsWithoutFinances: action.payload };
    }
    case SET_SKIPPED_PPC_NEEDS_RECONNECT: {
      return { ...state, ppcNeedsReconnectSkipped: action.payload };
    }
    case SET_SP_API_EXPIRED_WARNING_SHOW: {
      return { ...state, spApiExpiredWarningShow: action.payload };
    }
    case SET_SP_API_EXPIRED_WARNING_SKIPPED: {
      return { ...state, spApiExpiredWarningSkipped: action.payload };
    }
    case PRODUCT_LEVEL_PROFIT_AND_LOSS_BANNER_SKIPPED: {
      return { ...state, productLevelProfitAndLossBannerSkipped: action.payload };
    }
    case SET_DASHBOARD_INSIGHTS_WIDGET_OPEN: {
      return { ...state, dashboardInsightsWidgetOpen: action.payload };
    }
    case SET_SERVICE_ENDING_BANNER_SHOW: {
      return { ...state, serviceEndingBannerShow: action.payload };
    }
    case SET_SERVICE_ENDING_BANNER_SKIPPED: {
      return { ...state, serviceEndingBannerSkipped: action.payload };
    }
    case SET_RECOMMENDED_ALTERNATIVE_BANNER_SHOW: {
      return { ...state, recommendedAlternativeBannerShow: action.payload };
    }
    case SET_RECOMMENDED_ALTERNATIVE_BANNER_SKIPPED: {
      return { ...state, recommendedAlternativeBannerSkipped: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default userPreferences;
